export default __webpack_public_path__ + "static/media/materialize.347bd764.png";